export default __webpack_public_path__ + "static/media/bb8.08163946.webp";